import { createServerFn } from '@tanstack/react-start'
import { PostAuthor, PostEntry, PostFrontmatter, PostListItem } from './types'

export type { PostAuthor, PostEntry, PostFrontmatter, PostListItem }

// --- Client Component Loading ---
// Lazy load components for rendering
// We need this on the client to render the MDX content
const componentModules = import.meta.glob('../content/blog/*.{md,mdx}') as Record<string, () => Promise<any>>

export function getPostComponent(slug: string) {
  for (const [path, load] of Object.entries(componentModules)) {
    const file = path.split('/').pop() ?? path
    const base = file.replace(/\.(md|mdx)$/i, '')
    if (base === slug) {
      return load
    }
  }
  return null
}

// --- Server Functions ---

export const getPosts = createServerFn({ method: 'GET' }).handler(async () => {
  try {
    console.log('[getPosts] Server function called')
    // We import the server-only logic dynamically to avoid bundling it on the client
    // However, since blog.server.ts uses import.meta.glob, it might still be processed by Vite
    const { fetchPosts } = await import('./blog.server')
    return fetchPosts()
  } catch (e) {
    console.error('[getPosts] Server function error:', e)
    throw e
  }
})

export const getPostBySlug = createServerFn({ method: 'GET' })
  .inputValidator((slug: string) => slug)
  .handler(async (ctx: any) => {
    try {
      const slug = ctx.data
      console.log(`[getPostBySlug] Server function called for slug: ${slug}`)
      const { fetchPostBySlug } = await import('./blog.server')
      return fetchPostBySlug(slug)
    } catch (e) {
      console.error('[getPostBySlug] Server function error:', e)
      throw e
    }
  })

export const getRelatedPosts = createServerFn({ method: 'GET' })
  .inputValidator((data: { slug: string; related?: string[] }) => data)
  .handler(async (ctx: any) => {
    try {
      const data = ctx.data
      const { fetchRelatedPosts } = await import('./blog.server')
      return fetchRelatedPosts(data.slug, data.related)
    } catch (e) {
       console.error('[getRelatedPosts] Server function error:', e)
       throw e
    }
  })
